import React, { useContext } from 'react';
import { FullReportContext } from '../../../../../../../Context/FullReportContext';
import {
  InitiativeRow,
  InitiativeValue
} from '../../../../../../../Models/InitiativeValue';
import { MultipleReportsModalOption } from '../../../../../../../Components/MultipleReportsModal/MultipleReportsModalSelect/MultipleReportsModalSelect';

const RECENT_REPORTS_LIMIT = 10;

export interface UseInitiativeCardProps {
  initiative: InitiativeValue;
}

export interface UseInitiativeCardReturnProps {
  isSeeRecentReportsBtnDisabled: boolean;
  onSeeDateRowReports: (index: number) => void;
  onSeeRecentReports: () => void;
}

export const UseInitiativeCard = ({
  initiative
}: UseInitiativeCardProps): UseInitiativeCardReturnProps => {
  const { showMultipleReports } = useContext(FullReportContext);

  const isSeeRecentReportsBtnDisabled =
    !initiative.rows || initiative.rows.length === 0;

  const onSeeRecentReports = React.useCallback(() => {
    let recentIncidents: MultipleReportsModalOption[] = [];

    initiative.rows.forEach((r: InitiativeRow) => {
      if (recentIncidents.length >= RECENT_REPORTS_LIMIT) return;

      recentIncidents = [
        ...recentIncidents,
        ...(r.related_reports as unknown as MultipleReportsModalOption[])
      ];
    });

    if (recentIncidents.length > 0) {
      showMultipleReports(
        recentIncidents,
        undefined,
        recentIncidents[0].incident_number
      );
    }
  }, [showMultipleReports, initiative]);

  const onSeeDateRowReports = React.useCallback(
    (rowIndex: number) => {
      let rowIncidents: MultipleReportsModalOption[] = [];

      if (
        !initiative.rows ||
        initiative.rows.length === 0 ||
        !initiative.rows[rowIndex]
      )
        return;

      rowIncidents = [
        ...rowIncidents,
        ...(initiative.rows[rowIndex]
          .related_reports as unknown as MultipleReportsModalOption[])
      ];

      if (rowIncidents.length > 0) {
        showMultipleReports(
          rowIncidents,
          undefined,
          rowIncidents[0].incident_number
        );
      }
    },
    [showMultipleReports, initiative]
  );

  return {
    isSeeRecentReportsBtnDisabled,
    onSeeDateRowReports,
    onSeeRecentReports
  };
};
